import React, { forwardRef } from 'react';
import { BaseButton } from './BaseButton.js';

/**
 * A button component that renders as a button element.
 * Supports various sizes, styles, and content types.
 * Label must be a string.
 *
 * @component
 */
const Button = forwardRef((props, ref) => {
    return React.createElement(BaseButton, { ...props, ref: ref });
});
Button.displayName = "Button";

export { Button };
//# sourceMappingURL=Button.js.map
